<div class="dialog-pqr">
    <div class="header">
        <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

        <mat-dialog-actions>
            <button mat-dialog-close class="close-x-button">×</button>
        </mat-dialog-actions>
    </div>

    <mat-dialog-content>
        <h1 class="title">Direitos e obrigações trabalhista</h1>
        <div class="panel">
            <app-tabela ngSkipHydration class="table-component" [cabecalhoCustomizado]="true">
                <ng-container cabecalho>
                    <tr>
                        <th class="table-header" style="width: 16%">Item</th>
                        <th class="table-header" style="width: 16%">Percentual (%)</th>
                    </tr>
                </ng-container>
                <ng-container corpo>
                    <tr *ngFor="let dados of dadosTabela">
                        <td class="table-cell align-left">Direitos e obrigações trabalhista</td>
                        <td class="table-cell">
                            <input disabled class="display-input text-green" value="{{ dados.percentual}}" />
                        </td>
                    </tr>
                </ng-container>
            </app-tabela>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="footer">
        <button class="close-button" mat-dialog-close>Fechar</button>
    </mat-dialog-actions>
</div>
